import {environment} from '../../environments/environment';

export const COOKIE_DOMAIN = '.cloud.bigconnect.io';
export const SERVER_API_URL = environment.SERVER_API_URL;
export const GOOGLE_SITE_KEY = environment.GOOGLE_SITE_KEY;
export const GOOGLE = 'google';
